/*!

=========================================================
* Paper Kit React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";

// reactstrap components
import {
  Button,
  Container,
} from "reactstrap";

function IndexHeader() {
  return (
    <>
      <div
        id={'home'}
        className="page-header section-dark"
        style={{
          backgroundImage:
            "url(" + require("assets/img/antoine-barres.jpg") + ")",
        }}
      >
        <div className="filter" />
        <div className="content-center">
          <Container style={{ textAlign: 'center' }}>
            <div className="title-brand">
              <h1 className="presentation-title"> Mortal Kombat <br></br> Defenders of the Earth </h1>
              <div className="fog-low">
                <img alt="..." src={require("assets/img/fog-low.png")} />
              </div>
              <div className="fog-low right">
                <img alt="..." src={require("assets/img/fog-low.png")} />
              </div>
            </div>
            <h2 className="presentation-subtitle text-center">
              A new fan-game Mugen experience
            </h2>
            <div className="d-none d-xl-block">
              <Button
                style={{ marginLeft: '18px', marginTop: '26px' }}
                className="btn"
                color="info"
                target="_blank"
                href="https://daniloabella.gamejolt.io/MKDE"
              >
                <h2 style={{ marginTop: '0px', paddingTop: '8px', paddingBottom: '8px', paddingLeft: '20px', paddingRight: '20px' }}> Download</h2>
              </Button>
            </div>
          </Container>
        </div>
        <video muted autoPlay={true} loop={1} title="header"
          id={'home'}
          src={require("assets/videos/MKDOTE_Header.mp4")} type="video/mp4"
          style={{ position: 'absolute', zIndex: '-1' }}
        />
        <h6 className="category category-absolute">
          Created by
          <a href="https://daniloabella.com/">
            <img
              alt="..."
              className="creative-tim-logo"
              src={require("assets/img/Index/Daniloabella.png")}
            />
          </a>
        </h6>
      </div>
    </>
  );
}

export default IndexHeader;
